import type { ModuleId } from "./modules";

/** One line icon per module, drawn inline so the shell ships no icon font. Stroke follows the tile's accent colour. */
export function ModuleIcon({ id }: { id: ModuleId }) {
  const common = { width: 22, height: 22, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.7, strokeLinecap: "round" as const, strokeLinejoin: "round" as const, "aria-hidden": true };
  switch (id) {
    case "scope":     // a document being written
      return <svg {...common}><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" /><path d="M14 3v6h6" /><path d="M8 13h8" /><path d="M8 17h5" /></svg>;
    case "report":    // bars
      return <svg {...common}><path d="M18 20V10" /><path d="M12 20V4" /><path d="M6 20v-6" /><path d="M3 20h18" /></svg>;
    case "templates": // section layout
      return <svg {...common}><rect x="3" y="3" width="18" height="6" rx="1.2" /><rect x="3" y="13" width="10" height="8" rx="1.2" /><rect x="17" y="13" width="4" height="8" rx="1.2" /></svg>;
    case "agents":    // the agent itself
      return <svg {...common}><rect x="3" y="10" width="18" height="11" rx="2.2" /><circle cx="12" cy="4.5" r="1.6" /><path d="M12 6v4" /><circle cx="8.5" cy="15.5" r="1" fill="currentColor" /><circle cx="15.5" cy="15.5" r="1" fill="currentColor" /><path d="M9 19h6" /></svg>;
    case "admin":     // a shield with a check
      return <svg {...common}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><path d="m9 12 2 2 4-4" /></svg>;
  }
}
